import React from "react";
import cn from "classnames";
import { Ripple } from "./Ripple";
export function RippleContainer(_a) {
    var ripples = _a.ripples, className = _a.className, rippleClassName = _a.rippleClassName, timeout = _a.timeout, classNames = _a.classNames, entered = _a.entered, exited = _a.exited;
    return (React.createElement("span", { className: cn("rmd-ripple-container", className) }, ripples.map(function (ripple) { return (React.createElement(Ripple, { key: ripple.startTime, ripple: ripple, className: rippleClassName, entered: entered, exited: exited, timeout: timeout, classNames: classNames })); })));
}
//# sourceMappingURL=RippleContainer.js.map